import { render, staticRenderFns } from "./SecondaryFooter.vue?vue&type=template&id=7b38accb&scoped=true&"
import script from "./SecondaryFooter.vue?vue&type=script&lang=ts&"
export * from "./SecondaryFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryFooter.vue?vue&type=style&index=0&id=7b38accb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38accb",
  null
  
)

export default component.exports